import { ActivityType } from "../../lesson/activity/activity.types"

export interface LessonActivity {
  pk_lesson_activity_id: number,
  pk_lesson_activity_key: string,
  fk_student_key: string,
  fk_sub_id: number,
  fk_sest_key: string,
  fk_lesson_key: string,
  fk_activity_node_id: number,
  activity_type: number,
  sort_order: number,
  fk_tut_key: string,
  status: number,
  is_deleted: 0 | 1,
  marked_for_homework: 0 | 1,
  created_on: string,
  updated_on: null,
  tutor_comments: string,
  fk_activity_level_id: number | null,
  is_move: 0 | 1,
  fk_move_ses_key: string | null,
  is_skip_complete: 0 | 1,
  activity_ref_id: string | null,
  coins_earned: number,
  level_name: string | null,
  topic_name: string | null,
  roll_date: string | null,
  mastryScore: number,
  LessonActivitiesQuestions: LessonActivityQuestionBase[]
  total_activity_time: number | null,

  activity_node: {
    name?: string,
    node_name?: string
    video_name?: string,
    activity_name?: string,
  }[]
}

interface LessonActivityQuestionBase {
  pk_lesson_activity_question_id: number,
  pk_lesson_activity_question_key: string,
  fk_student_key: string,
  fk_lesson_key: string,
  fk_question_id: number,
  fk_sub_id: string,
  fk_lesson_activity_key: string,
  marked_for_manual_marking: number,
  fk_tut_key: string,
  topic_id: number,
  created_on: string,
  updated_on: string | null,
  is_manual: 0 | 1,
}


export interface LessonActivityEnglishAQ extends LessonActivity {
  activity_type: ActivityType.PLATFORM_ONLINE_ACTIVITY | ActivityType.PLATFORM_SUMMATIVE,
  fk_sub_id: 1
  LessonActivitiesQuestions: LessonActivityEnglishQuestionAQ[]
  activity_node: PlatformActivityNode[]
}
interface LessonActivityEnglishQuestionAQ extends LessonActivityQuestionBase {
  english_question: EnglishAQ[]
}
interface EnglishAQ {
  english_question_category_id: number,
  english_question_parts: {
    markedReport: number
    english_question_part_automark: number
    english_question_answers: {
      english_answer_text: string,
    }[]
    StudentAnsAttempts: StudentAnsAttempt[]
  }[]
}


export interface LessonActivityMathAQ extends LessonActivity {
  activity_type: ActivityType.PLATFORM_ONLINE_ACTIVITY | ActivityType.PLATFORM_SUMMATIVE,
  fk_sub_id: 2
  LessonActivitiesQuestions: LessonActivityQuestionMathAQ[]
  activity_node: PlatformActivityNode[]
}
interface LessonActivityQuestionMathAQ extends LessonActivityQuestionBase {
  question: MathAQ[]
}
interface MathAQ {
  question_parts: {
    markedReport: number
    StudentAnsAttempts: StudentAnsAttempt[]
  }[]
}



const LIBRARY_TYPES = [
  ActivityType.MY_LIBRARY_WORKSHEET, ActivityType.TUTOR_LIBRARY_ITEM,
  ActivityType.MY_LIBRARY_LINK, ActivityType.MY_LIBRARY_VIDEO,
  ActivityType.MY_LIBRARY_TASK
] as const;
export interface LessonActivityLibrary extends LessonActivity {
  activity_type: typeof LIBRARY_TYPES[number],
  LessonActivitiesQuestions: LessonActivityQuestionLibrary[]
  activity_node: LibraryItemActivityNode[]
}
export function isActivityLibrary(activity: LessonActivity): activity is LessonActivityLibrary {
  return LIBRARY_TYPES.includes(activity.activity_type)
}
interface LessonActivityQuestionLibrary extends LessonActivityQuestionBase {
  question: LibraryQuestion[]
}
interface LibraryQuestion extends LibraryItemActivityNode {
  StudentAnsAttempts: StudentAnsAttempt[]
}



export interface LessonActivityPlatformVideo extends LessonActivity {
  activity_type: ActivityType.PLATFORM_VIDEO,
  LessonActivitiesQuestions: LessonActivityQuestionPlatformVideo[]
  activity_node: PlatformVideoActivityNode[]
}
export function isActivityPlatformVideo(activity: LessonActivity): activity is LessonActivityPlatformVideo {
  return ActivityType.PLATFORM_VIDEO === activity.activity_type
}
interface LessonActivityQuestionPlatformVideo extends LessonActivityQuestionBase {
  question: PlatformVideoQuestion[]
}
interface PlatformVideoQuestion extends PlatformVideoActivityNode {
  StudentAnsAttempts: StudentAnsAttempt[]
}



export interface LessonActivityPlatformWorksheet extends LessonActivity {
  activity_type: ActivityType.PLATFORM_WORKSHEET,
  LessonActivitiesQuestions: LessonActivityQuestionPlatformWorksheet[]
  activity_node: PlatformWorksheetActivityNode[]
}
export function isActivityPlatformWorksheet(activity: LessonActivity): activity is LessonActivityPlatformWorksheet {
  return ActivityType.PLATFORM_WORKSHEET === activity.activity_type
}
interface LessonActivityQuestionPlatformWorksheet extends LessonActivityQuestionBase {
  question: []
  StudentAnsAttempts: []
}

export interface LessonActivityOnetime extends LessonActivity {
  activity_type: ActivityType.ONETIME,
  LessonActivitiesQuestions: LessonActivityQuestionOnetime[]
  activity_node: OnetimeActivityNode[]
}
export function isActivityOnetime(activity: LessonActivity): activity is LessonActivityOnetime {
  return ActivityType.ONETIME === activity.activity_type
}
interface LessonActivityQuestionOnetime extends LessonActivityQuestionBase {
  question: OnetimeQuestion[]
}
interface OnetimeQuestion extends OnetimeActivityNode {
  StudentAnsAttempts: StudentAnsAttempt[]
}




export interface StudentAnsAttempt {
  submitted_on: number;
  points_obtained: number;
}


interface PlatformActivityNode {
  activity_node_id: number,
  node_name: string,
  sort_order: number,
  is_deleted: 0 | 1,
  created_at: string,
  updated_at: string
}

interface LibraryItemActivityNode {
  pk_tutor_library_item_id: number,
  pk_tutor_library_item_key: string,
  name: string,
  duration: string,
  fk_tut_key: string,
  fk_sub_id: number,
  activity_type: number,
  link: string | null,
  is_deleted: 0 | 1,
  created_on: string,
  updated_on: string,
  deleted_on: string | null,
  fk_activity_topic_id: number | null,
  source: string,
  is_hide: 0 | 1,
  description: string | null,
  coins: number,
  fk_folder_key: string
}

interface PlatformVideoActivityNode {
  id: number,
  topic_id: number,
  video_name: string,
  video_url: string,
  activity_node_id: number,
  soft_delete: 0 | 1
}

interface PlatformWorksheetActivityNode {
  "id": number,
  "subject_id": number,
  "download_by": number,
  "topic_id": number,
  "node_id": number,
  "file_type": number,
  "file_name": string,
  "download_at": string,
  "file_name_answer": string,
  "source": string,
  "activity_node_id": number,
  "node_name": string,
  "sort_order": number,
  "is_deleted": 0 | 1,
  "created_at": string,
  "updated_at": string
}

interface OnetimeActivityNode {
  pk_onetime_activity_id: number,
  pk_onetime_activity_key: string,
  fk_student_key: string,
  fk_tutor_key: string,
  fk_session_key: string,
  fk_lesson_key: string,
  name: string,
  activity_subtype: number,
  description: string,
  duration: string,
  coins: number,
  metadata: object,
  is_deleted: 0 | 1,
  created_on: string,
  updated_on: string
}